const GAP = 12;
const MIN_TILE_WIDTH = 128;
const MAX_TILE_WIDTH = 640;

/** Fit the largest readable 4:3 tiles into the room's remaining space.
 * Very short rooms keep readable tiles and let the room scroll instead. */
export function voiceGridLayout(count: number, width: number, height: number) {
  const availableWidth = Math.max(0, width);
  const availableHeight = Math.max(0, height);
  if (count <= 0 || !availableWidth) return { width: 0, height: 0, tileWidth: 0, tileHeight: 0, columns: 1 };
  let columns = 1;
  let tileWidth = 0;
  for (let candidate = 1; candidate <= count; candidate++) {
    const rows = Math.ceil(count / candidate);
    const fitted = Math.floor(Math.min(
      MAX_TILE_WIDTH,
      (availableWidth - GAP * (candidate - 1)) / candidate,
      (availableHeight - GAP * (rows - 1)) / rows * 4 / 3,
    ));
    if (fitted > tileWidth) { tileWidth = fitted; columns = candidate; }
  }
  if (tileWidth < Math.min(MIN_TILE_WIDTH, availableWidth)) {
    columns = Math.max(1, Math.min(count, Math.floor((availableWidth + GAP) / (MIN_TILE_WIDTH + GAP))));
    tileWidth = Math.floor(Math.min(MAX_TILE_WIDTH, (availableWidth - GAP * (columns - 1)) / columns));
  }
  const tileHeight = tileWidth * 3 / 4;
  return {
    columns,
    tileWidth,
    tileHeight,
    width: columns * tileWidth + GAP * (columns - 1),
    height: Math.ceil(count / columns) * tileHeight + GAP * (Math.ceil(count / columns) - 1),
  };
}
